//PROVIDER
import { createContext, useContext, useState } from "react";
import { createSession, getToken } from "../services/api_base";
import { useNavigate } from "react-router-dom";
import { getActiveTenant, listTenants, setSession, clearSession, getSession } from "../config/tenants";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const tenant = getActiveTenant();
  const [token, setToken] = useState(getToken() || null);

  const logins = async (login, password) => {
    const response = await createSession(login, password);
    if (response.data) {
      setToken(response.data.token);
      setSession(tenant.slug, {
        token: response.data.token,
        name: response.data.nome,
        userId: response.data.userId,
      });
      navigate(`/logs_pathfind`);
    } else {
      console.error("Falha na autenticação:", response.data.error);
    }
  };

  // Encerra só a sessão do cliente ativo; as dos outros clientes permanecem.
  const logout = () => {
    setToken(null);
    if (tenant) clearSession(tenant.slug);
  };

  const userName = tenant ? getSession(tenant.slug).name : null;

  return (
    <AuthContext.Provider value={{ token, logins, logout, tenant, tenants: listTenants(), userName }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
